import _objectSpread from "@babel/runtime-corejs2/helpers/objectSpread2";
import _objectWithoutProperties from "@babel/runtime-corejs2/helpers/objectWithoutProperties";
import _extends from "@babel/runtime-corejs2/helpers/extends";
var _excluded = ["serverHandler"];
import _Promise from "@babel/runtime-corejs2/core-js/promise";
import { reduxForm } from 'redux-form';
import * as React from 'react';
import hoistNonReactStatic from 'hoist-non-react-statics';
import { getDisplayName } from 'gandi.react-helpers';
var withForm = function withForm(config) {
  return function (WrappedComponent) {
    var WithForm = /*#__PURE__*/React.forwardRef(function (props, ref) {
      return /*#__PURE__*/React.createElement(WrappedComponent, _extends({}, props, {
        ref: ref
      }));
    });
    var serverHandler = config.serverHandler,
      reduxFormConfig = _objectWithoutProperties(config, _excluded);
    var WithFormDecorated = reduxForm(_objectSpread({
      getFormState: function getFormState(state) {
        return state.gandiForm;
      }
    }, reduxFormConfig))(WithForm);

    // This fixes a problem related to the prefetch.
    // Redux-form does not handle well.
    var HoistedComponent = hoistNonReactStatic(WithFormDecorated,
    // $FlowIgnore[not-an-object]
    WrappedComponent);

    // For @connect et al, this is the de facto way to access decorated component.
    // $FlowFixMe[incompatible-use]
    HoistedComponent.WrappedComponent = WrappedComponent;
    // Display the correct name in react inspector and error stack traces
    HoistedComponent.displayName = "DecoratorComponent(".concat(getDisplayName(WrappedComponent), ")");
    if (serverHandler) {
      HoistedComponent.handleForm = function (args) {
        var req = args.req;
        if (req.method === 'POST') {
          var data = req.body || {};

          // 'csrf' is not yet dispatched in the store here; let's use the one in the session:
          var session = req.websession || req.session;
          if (session.csrf && session.csrf.token && data['_csrf_token'] !== session.csrf.token // eslint-disable-line dot-notation
          ) {
            // Let's not reject an Error, it would log a traceback.
            // eslint-disable-next-line prefer-promise-reject-errors
            return _Promise.reject('Invalid CSRF token!');
          }
          return serverHandler(args);
        }
        return _Promise.resolve();
      };
    }
    return HoistedComponent;
  };
};
export default withForm;